import { MOTIVATION_MODEL_KEY_POINTER } from 'models/daos/motivation/constants'

const MOTIVATION_DOMAIN = 'motivation'
const MOTIVATION_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const MOTIVATION_DOMAIN_MAP_KEY = MOTIVATION_MODEL_KEY_POINTER

export {
  MOTIVATION_DOMAIN,
  MOTIVATION_DOMAIN_MAP_KEY,
  MOTIVATION_STATE
}
